import { Component, ElementRef, ViewChild, ViewContainerRef } from "@angular/core";
import { ICellEditorAngularComp } from "ag-grid-angular";


@Component({
    selector: 'app-cell-lista-editor',
    template: `<div class="lista-editor">
                    <input 
                        #input 
                        type="text"
                        class="lista-input"
                        [(ngModel)]="valor"
                        (ngModelChange)="buscar()"
                        (keydown)="onkeyDown($event)"
                        autocomplete="off"
                    >
                    <div class="lista-opciones">
                        <div *ngFor="
                            let opcion of opcionesFiltradas;
                            let i = index
                        "
                        [id]="'lista-opcion-' + i"
                        class="lista-opcion"
                        [class.seleccionada]="i === indiceSeleccionado"
                        (mousedown)="seleccionar(opcion)"
                        >
                        {{opcion}}
                        </div>
                        <div *ngIf="opcionesFiltradas.length === 0"
                        class ="sin-resultados">
                        sin resultados
                        </div>
                    </div>
                </div>
                    `,
    styles:[`.lista-editor{
        width: 220px;
        background: white;
        boder: 1px solid #ccc;
        box-shadow: 0 2px 6px rgba(0,0,0,.20)
    }
    .lista-input{
        width: 100%;
        height:30px;
        box-sizing: border-box;
        padding: 5px 8px;
        border: none;
        boder-bottom: 1px solid #ccc;
        outline: none;
    }
    .lista-opciones{
        max-height: 200px;
        overflow-y: auto;
    }
    .lista-opcion {
        padding: 6px 8px;
        cursor: pointer;
    }
    .lista-opcion:hover{
        background:#eeeeee;
    }
    .lista-opcion.seleccionada{
        background: #dbeafe
    }
    .sin-resultados {
        padding: 6px 8px;
        color: #999;
    }
    `]
})
export class CellListaEditorComponent implements ICellEditorAngularComp {

    @ViewChild('input', { static: false })
    input: ElementRef
    params: any

    valor: string = '';

    opciones: string[] = []

    opcionesFiltradas: string[] = []

    indiceSeleccionado: number = -1;
    cancelado: boolean = false

    agInit(params: any): void {
        this.params = params

        this.opciones = params.values || [];

        if (params.charPress) {
            this.valor = params.charPress
        } else {
            this.valor = params.value !== null &&
                params.value !== undefined
                ? params.value.toString()
                : ''
        }
        this.opcionesFiltradas = this.filtraOpciones();
        this.indiceSeleccionado = this.obtenerIndiceInicial();

    }
    afterGuiAttached(): void {
        setTimeout(() => {
            if (this.input) {
                this.input.nativeElement.focus();

                if (this.params.charPress) {
                    const input = this.input.nativeElement
                    input.setSelectionRange(
                        input.value.length,
                        input.value.length
                    )
                } else {
                    this.input.nativeElement.select()
                }
            }
        });
    }

    getValue(): any {
        return this.valor
    }
    isPopup(): boolean {
        return true
    }
    getPopupPosition(): string {
        return 'under';
    }
    isCancelAfterEnd(): boolean {
        return this.cancelado
    }
    buscar(): void {
        this.opcionesFiltradas = this.filtraOpciones();

        if (this.opcionesFiltradas.length > 0) {
            this.indiceSeleccionado = 0
        } else {
            this.indiceSeleccionado = -1
        }
    }
    filtraOpciones(): string[] {
        const texto = (this.valor || '')
            .toString()
            .trim()
            .toLowerCase()

        if (!texto) {
            return [...this.opciones]
        }
        return this.opciones.filter(opcion => {
            return opcion
                .toString()
                .toLowerCase()
                .indexOf(texto) !== -1
        })
    }
    obtenerIndiceInicial(): number {
        if (!this.valor) {
            return this.opcionesFiltradas.length > 0 ? 0 : -1;

        }
        const indice = this.opcionesFiltradas.findIndex(opcion => {
            opcion.toString() === this.valor.toString()
        })
        return indice >= 0 ? indice : (this.opcionesFiltradas.length > 0 ? 0 : -1)
    }
    seleccionar(opcion: string): void {
        this.valor = opcion;
        this.cancelado = false
        this.params.api.stopEditing();
    }
    onkeyDown(event: KeyboardEvent): void {
        const key = event.key

        if (key === 'Enter') {
            event.preventDefault()
            event.stopPropagation();

            if (this.indiceSeleccionado >= 0 && this.indiceSeleccionado < this.opcionesFiltradas.length) {
                this.valor = this.opciones[this.indiceSeleccionado]
            }
            this.cancelado = false
            this.params.api.stopEditing();

            return
        }
        if (key === 'Escape') {
            event.preventDefault();
            event.stopPropagation()
            this.cancelado = true
            this.params.api.stopEditing()

            return
        }
        if (key === 'ArrowDown') {
            event.preventDefault();
            event.stopPropagation()
            if (this.opcionesFiltradas.length === 0) {
                return
            }
            if (this.indiceSeleccionado < this.opcionesFiltradas.length - 1) {
                this.indiceSeleccionado++
            } else {
                this.indiceSeleccionado = 0;

            }
            
            return
        }
        if (key === 'ArrowUp') {
            event.preventDefault();
            event.stopPropagation()
            if (this.opcionesFiltradas.length === 0) {
                return
            }
            if (this.indiceSeleccionado > 0) {
                this.indiceSeleccionado--
            } else {
                this.indiceSeleccionado = this.opcionesFiltradas.length - 1;

            }
            
            return
        }
        if (key === 'Tab') {
            return
        }
        event.stopPropagation();
    }
    
    // scrollOpcionVisible(): void {
    //     setTimeout(() => {
    //         const elemento = document.getElementById(
    //             'lista-opcion-' + this.indiceSeleccionado
    //         )
    //         if (elemento) {
    //             elemento.scrollIntoView({
    //                 block: 'nearest'
    //             })
    //         }
    //     });
    // }
}